import { useQuery } from '@apollo/client';
import type { SafetyAction } from '@communities/content-management/domain';
import { GET_COMMUNITY_ACTIONS } from '@communities/content-management/graphql';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain/errors';
import { useMemo } from 'react';

interface CommunityActionsResponse {
  community: {
    id: string;
    actions: SafetyAction[];
  } | null;
}

export function useCommunityActions(communityId?: string) {
  const { data, loading, error, refetch } = useQuery<CommunityActionsResponse>(GET_COMMUNITY_ACTIONS, {
    variables: { communityId },
    fetchPolicy: 'cache-first',
    skip: !communityId,
  });

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  const actions: SafetyAction[] = data?.community?.actions || [];

  return {
    actions,
    loading,
    errors,
    refetch,
  };
}

export default useCommunityActions;
